import React from 'react'
import Sidebar from './sidebar/Sidebar'
import AccessPageBlock from './access/AccessPageBlock'

const LayoutMain = ({ children }) => {
  return (
    <div className='layout'>
		<AccessPageBlock />
        <Sidebar />
        <div className='main'>
            { children }
        </div>
    </div>
  )
}

export default LayoutMain